import CustomAnimation from "../CustomLoader/CustomAnimation";

/**
 *
 * @param loading - boolean
 * @param children - ReactNode
 */
export const LoaderWrapper = ({ loading, children }) => {
  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        margin: "0",
        padding: "0",
        height: "100%",
      }}
    >
      <CustomAnimation visible={loading} />
      {children}
    </div>
  );
};
